export interface BeforeInstallPromptEvent extends Event {
  readonly platforms: string[];
  readonly userChoice: Promise<{ outcome: 'accepted' | 'dismissed'; platform: string }>;
  prompt(): Promise<void>;
}

declare global {
  interface WindowEventMap {
    beforeinstallprompt: BeforeInstallPromptEvent;
  }
}

export const PWA_INSTALL_DISMISSED_KEY = 'pwa_install_dismissed_at';
export const PWA_INSTALL_COOLDOWN_MS = 7 * 24 * 60 * 60 * 1000;
